import { render } from "./Item.vue?vue&type=template&id=4d106486"
import script from "./Item.vue?vue&type=script&lang=js"
export * from "./Item.vue?vue&type=script&lang=js"
script.render = render

export default script